import PropTypes from 'prop-types';
import {
  lazy, Suspense, useMemo, useState
} from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import Button from '@mui/material/Button';
import { useTranslation } from '../../hooks';
import { HasPermission } from '@febos-io/auth';

const AttachmentViewer = lazy(() => import('@febos-io/design').then((mod) => ({ default: mod.AttachmentViewer, })));

const FileThumbnail = lazy(() => import('@febos-io/design').then((mod) => ({ default: mod.FileThumbnail, })));

const ImageThumbnail = lazy(() => import('@febos-io/design').then((mod) => ({ default: mod.ImageThumbnail, })));

// TODO: Add suport by count image render
export function FilePreview({
  file,
  height,
  width,
  onImageClick,
  onDownloadReport,
  list,
  className,
  isLoading,
  buttonDownloadReportPermissions,
}) {
  const [preview, setPreview] = useState(false);
  const { t } = useTranslation();

  const isImage = useMemo(() => {
    return file.type.startsWith('image');
  }, [file.type]);

  const handleClick = async () => {
    if (onImageClick && isImage) {
      onImageClick(file);
      return;
    }
    setPreview(true);
  };
  const anayisisId =
    file?.metadata?.anayisisId || file?.metadata?.analysisId || file?.metadata?.analisisId;

  const handleDownloadReport = () => {
    if (onDownloadReport) {
      onDownloadReport(file);
    }
  };

  return (
    <Suspense>
      <div className={`col-auto ${className}`} title={isImage ? null : file.name}>
        {isImage || file.preview ? (
          <ImageThumbnail
            key={'prev' + file.id}
            file={file}
            height={height}
            width={width}
            onClick={handleClick}
          />
        ) : (
          <FileThumbnail name={file.name} height={height} width={width} onClick={handleClick} />
        )}
        {!isLoading && anayisisId && onDownloadReport && (
          <HasPermission permission={[buttonDownloadReportPermissions]}>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={handleDownloadReport}
              sx={{ mt: 1 }}
            >
              {t('Download report')}
            </Button>
          </HasPermission>
        )}
        {preview ? (
          <Suspense fallback={<div>{t('Loading preview...')}</div>}>
            <AttachmentViewer
              name={file.name}
              file={file}
              mimetype={file.type}
              list={list}
              onClose={() => {
                setPreview(false);
              }}
            />
          </Suspense>
        ) : null}
      </div>
    </Suspense>
  );
}

FilePreview.propTypes = {
  file: PropTypes.object,
  height: PropTypes.number,
  width: PropTypes.number,
  onImageClick: PropTypes.func,
  onDownloadReport: PropTypes.func,
  list: PropTypes.array,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  buttonDownloadReportPermissions: PropTypes.string,
};

export default FilePreview;
